export const TAG = 'OpenActions';

export const SHOWN_ITEMS_DEFAULT = 5;
export const CASH_TRANSFER_DETAILS_QUERY_KEY = 'cashTransferDetails';
export const CASH_DEPOSIT_DETAILS_QUERY_KEY = 'cashDepositDetails';
export const CASH_WITHDRAWAL_DETAILS_QUERY_KEY = 'cashWithdrawalDetails';
export const CASH_CURRENCY_CONVERSION_QUERY_KEY = 'cashCurrencyConversionDetails';
export const ADD_BANK_ACCOUNT_DETAILS_QUERY_KEY = 'addBankAccountDetailsQueryKey';
export const REMOVE_BANK_ACCOUNT_DETAILS_QUERY_KEY = 'removeBankAccountDetailsQueryKey';
